import { DimensionsDTO } from "@/lib/shared-types";
import { t } from "i18next";
import { ComputeFieldComponent } from "../../computeFields";

export const isValidDimField = (field: unknown) => {
  return (
    field != undefined &&
    !(Number(field) <= 0) &&
    field !== "undefined" &&
    field !== "0" &&
    field != "" &&
    field != "false" &&
    field != false
  );
};

export function hasDisplayableDimensions(
  input?:
    | (DimensionsDTO & {
        unknownDimensions?: boolean;
        rawDimensions?: string;
      })
    | null,
): boolean {
  if (!input) return false;
  if (typeof input.rawDimensions === "string" && input.rawDimensions.trim()) {
    return true;
  }
  if (input.unknownDimensions === true) return true;
  return (
    isValidDimField(input.cm_width) ||
    isValidDimField(input.cm_height) ||
    isValidDimField(input.cm_depth) ||
    isValidDimField(input.cm_diameter)
  );
}

export const DimensionsFormatting: ComputeFieldComponent<
  DimensionsDTO & { unknownDimensions?: boolean; rawDimensions?: string }
> = ({
       input: { unknownDimensions = false, rawDimensions, ...input },
       lineBreak = false,
       language,
     }) => {
  if (rawDimensions) {
    return <>{rawDimensions}</>;
  }

  // « Dim. inconnues » uniquement si la case est explicitement cochée.
  if (unknownDimensions === true) {
    return (
      <>
        {t("computeField.dimensionsUnknown", { lng: language })}
        {lineBreak && <br />}
      </>
    );
  }

  if (
    !input ||
    (!isValidDimField(input.cm_width) &&
      !isValidDimField(input.cm_height) &&
      !isValidDimField(input.cm_depth) &&
      !isValidDimField(input.cm_diameter))
  ) {
    return null;
  }

  const cmDimensions = [
    input.cm_height,
    input.cm_width,
    input.cm_depth,
    isValidDimField(input.cm_diameter) ? `ø ${input.cm_diameter}` : undefined,
  ]
    .filter(isValidDimField)
    .join(" x ");

  const inDimensions = [
    input.in_height,
    input.in_width,
    input.in_depth,
    isValidDimField(input.in_diameter) ? `ø ${input.in_diameter}` : undefined,
  ]
    .filter(isValidDimField)
    .join(" x ");

  return (
    <>
      {cmDimensions} cm - {inDimensions} in.
      {lineBreak && <br />}
    </>
  );
};
